<template>
    <b-tabs content-class="mt-3">
        <b-tab
            active
            title="Ejecutivos"
            v-if="userCan('view-management-indicators')"
        >
            <app-management-indicators></app-management-indicators>
        </b-tab>
        <b-tab
            title="Supervisores"
            v-if="userCan('view-supervisor-indicators')"
        >
            <app-supervisor-indicators></app-supervisor-indicators>
        </b-tab>
        <b-tab
            title="Incentivos Supervisores"
            v-if="userCan('view-supervisor-bonuses')"
        >
            <app-supervisor-bonus-page />
        </b-tab>
    </b-tabs>
</template>
<script>
import appManagementIndicators from './ManagementIndicators'
import appSupervisorIndicators from './SupervisorIndicators'
import appSupervisorBonusPage from './SupervisorBonusPage'
export default {
    components: {
        appManagementIndicators,
        appSupervisorIndicators,
        appSupervisorBonusPage,
    },
}
</script>
